<template>
  <default-layout>
    <div class="locations pt-5">
      <div class="mb-5">
        <b-container class="mt-4">
          <div class="text-center mb-3">
            <h1 class="h2">ZoopLocal is currently available in:</h1>
            <ul class="list-unstyled mb-0">
              <li v-for="region in regionsAvailable" :key="region.slug">
                <strong>{{ region.name }}</strong>
              </li>
            </ul>
          </div>
          <div class="text-center mb-4">
            <p>
              Want to see ZoopLocal in your area? Send us an email at
              <a href="mailto:support@zooplocal.com">support@zooplocal.com</a>
              to let us know.
            </p>
            <p>
              We look forward to hearing from you!
            </p>
          </div>
        </b-container>
      </div>
      <div class="bg-light py-4">
        <b-container>
          <div class="text-center mb-4">
            <h2 class="h4">Explore Listings in {{ currentRegion.name }}</h2>
          </div>
          <category-thumbnails/>
          <div class="text-center mt-3 pb-3">
            <b-button
              variant="primary"
              squared
              :to="`/listings/${currentRegion.slug}`">
              See all categories
            </b-button>
          </div>
        </b-container>
      </div>
    </div>
  </default-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import CategoryThumbnails from '@/components/listings/CategoryThumbnails.vue'

export default {
  name: 'Locations',
  components: {
    CategoryThumbnails,
  },
  computed: {
    ...mapGetters('Region', {
      currentRegion: 'current',
      regionsAvailable: 'available',
    }),
  },
}
</script>
